export default "__VITE_PUBLIC_ASSET__740483b6__"